import { HTTP } from "../../services/api-service.js";
import commonObj from "../../services/common.js";
var common = new commonObj();
var baseUrl = common.baseURL;

const marketInfoStore = {
  namespaced: true,
  actions: {
    getSKUList({ commit, state }, param) {
      let reqObj = {
        brandCode: "",
        cate1Code: "",
        cate2Code: "",
        searchCriteria: "",
        orderBy: "SKU_Desc,asc",
        take: 10000000,
        skip: 0,
        lowPrice: false
      };
      reqObj = Object.assign(reqObj, param);
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/Compare/SearchDataByPrice", reqObj)
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getSiteList({ commit, state }, param = {}) {
      let reqObj = {
        tableNeedQuery: "CP_Site",
        isOuterJoin: false,
        searchCriteria: "",
        orderBy: "Seq,asc",
        take: 10000000,
        skip: 0
      };
      reqObj = Object.assign(reqObj, param);
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/qgl/listvalue", reqObj)
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getCompareList({ commit, state }, param = {}) {
      let reqObj = {
        tableNeedQuery: "CP_Compare",
        isOuterJoin: false,
        searchCriteria: "",
        orderBy: "",
        take: 10000000,
        skip: 0
      };
      reqObj = Object.assign(reqObj, param);
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/qgl/listvalue", reqObj)
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getDailyDataList({ commit, state }, param = {}) {
      const baseSql = `BatchNo = (select max(BatchNo) from CP_DailyData where SiteName ='${param.SiteName}')`;
      let searchSql = param.searchKey
        ? `and (SKU like N'%${param.searchKey}%' OR SKU_Desc like N'%${param.searchKey}%' OR SKU_Url like N'%${param.searchKey}%')`
        : "";
      let reqObj = {
        tableNeedQuery: "CP_DailyData",
        isOuterJoin: false,
        searchCriteria: baseSql + searchSql,
        orderBy: "SKU_Desc,asc",
        take: 10000000,
        skip: 0
      };
      reqObj.skip = param.skip ? param.skip : 0;
      reqObj.take = param.take ? param.take : 10000000;
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/qgl/listvalue", reqObj)
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    refreshSkuData({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        // SiteName 为空的时候，刷新所有的网站
        HTTP.post(baseUrl + "/Compare/RefreshData", param)
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    saveSku({ commit }, dataList) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/mm/save",
          JSON.stringify({
            type: "CP_SKU",
            modelList: dataList,
            option: 1
          })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    saveCompareList({ commit }, dataList) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/mm/save",
          JSON.stringify({
            type: "CP_Compare",
            modelList: dataList,
            option: 1
          })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    exportFile({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/mm/export", state.q, { responseType: "blob" })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    printTXF({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/stockTransfer/printstktxf",
          { txNum: param.txNum, rptID: param.rptID },
          { responseType: "blob" }
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    }
  }
};
export default marketInfoStore;
